import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, BRAND } from "@/data/content";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-[#0A0A0A]/70 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="/logo/designlayer-full-white.png"
            alt="Designlayer"
            className="h-20 md:h-24 w-auto opacity-95 group-hover:opacity-100 transition-opacity"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.slice(1, 9).map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[12px] font-mono uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-[#B58B5D]" : "text-[#A3A3A3] hover:text-[#EAEAEA]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="nav-cta-contact" className="dl-btn-primary !py-2.5 !px-4 text-[10px]">
            Contact
          </Link>
        </nav>

        <button
          aria-label="Toggle menu"
          data-testid="nav-menu-toggle"
          className="lg:hidden text-[#EAEAEA] p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-white/5 bg-[#0A0A0A]/95 backdrop-blur-xl">
          <div className="px-6 py-6 grid gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-mono uppercase tracking-[0.18em] ${
                    isActive ? "text-[#B58B5D]" : "text-[#EAEAEA]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
